"use client";

import { lazy, Suspense } from "react";
const SonnerToaster = lazy(() => import("./SonnerToaster").then(mod => ({
  default: mod.SonnerToaster
})));
export function AppToaster() {
  return <Suspense fallback={null} data-sentry-element="Suspense" data-sentry-component="AppToaster" data-sentry-source-file="AppToaster.tsx">
            <SonnerToaster data-sentry-element="SonnerToaster" data-sentry-source-file="AppToaster.tsx" />
        </Suspense>;
}